import { useTranslation } from "react-i18next";
import { Battery, Construction } from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function BessPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <Battery className="h-5 w-5 text-emerald-600" />
            <CardTitle>{t("bess.title")}</CardTitle>
          </div>
          <CardDescription>{t("bess.subtitle")}</CardDescription>
        </CardHeader>
      </Card>

      <Card>
        <CardContent className="p-6 space-y-4">
          <div className="flex items-start gap-3 rounded-lg bg-amber-50 border border-amber-200 p-4">
            <Construction className="h-5 w-5 text-amber-700 shrink-0 mt-0.5" />
            <div className="text-sm text-amber-900">
              <div className="font-medium">{t("bess.stub_header")}</div>
              <p className="mt-1">{t("bess.stub_body")}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <Field label={t("bess.capacity_kwh")} />
            <Field label={t("bess.soc_pct")} />
            <Field label={t("bess.charge_kw")} />
            <Field label={t("bess.discharge_kw")} />
            <Field label={t("bess.weighted_cost_uah_per_kwh")} />
            <Field label={t("bess.cycles_total")} />
            <Field label={t("bess.last_event")} />
            <Field label={t("bess.health_pct")} />
          </div>

          <div className="text-xs text-slate-500">{t("bess.roadmap_note")}</div>
        </CardContent>
      </Card>
    </div>
  );
}

function Field({ label }: { label: string }) {
  return (
    <div className="rounded-lg bg-slate-50 p-3">
      <div className="text-xs text-slate-500">{label}</div>
      <div className="font-mono text-lg text-slate-400">—</div>
    </div>
  );
}
